import { defineComponent as _defineComponent } from 'vue'
import BasicButton from '@/ui-components/BasicButton.vue';
import { COUNTRY_WITHOUT_TITLEDETAIL } from '@/constants/web-locales.constant';
import { useLanguageStore } from '@/helpers/composables/useStores';
import { computed, ref } from 'vue';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';


export default /*#__PURE__*/_defineComponent({
  __name: 'TitleRemovalBanner',
  setup(__props) {

const { webLocale } = useLanguageStore();

const isClosed = ref(false);
const showBanner = computed(() => {
	return COUNTRY_WITHOUT_TITLEDETAIL.includes(webLocale.value) && !isClosed.value;
});

const appLink = {
	ios: 'https://apps.apple.com/app/apple-store/id979227482',
	android: 'https://play.google.com/store/apps/details?id=com.justwatch.justwatch',
};

const deviceType = computed(() => {
	const userAgent = window.navigator.userAgent;

	if (!userAgent) {
		return undefined;
	}
	if (userAgent.match(/Windows|Linux/i)) {
		return 'android';
	} else if (userAgent.match(/Macintosh/i)) {
		return 'ios';
	}

	return [
		{ name: 'ios', matcher: /(iPhone|iPad)/i },
		{ name: 'android', matcher: /android/i },
	].reduce((root, item) => {
		return userAgent?.match(item.matcher) ? item.name : root;
	}, undefined);
});

const applicationUrl = computed(() => {
	return deviceType.value ? appLink[deviceType.value] : '';
});

const close = () => {
	isClosed.value = true;
	TrackingHelper.trackEvent('titleremovalbanner', {
		action: 'hide_click',
	});
};
const clickout = () => {
	TrackingHelper.trackEvent('titleremovalbanner', {
		action: 'clickout',
	});
};

return { __sfc: true,webLocale, isClosed, showBanner, appLink, deviceType, applicationUrl, close, clickout, BasicButton }
}

})